

Vue.component('employer-custom-questions', require('./vue/employer-custom-questions.vue').default);



// editor (till the end of this doc)
Vue.component('image-entry', require('./Editor/vue/lps/image-entry.vue').default);
Vue.component('text-entry', require('./Editor/vue/lps/text-entry.vue').default);
Vue.component('master-title', require('./Editor/vue/lps/master_title.vue').default);
Vue.component('slave-title', require('./Editor/vue/lps/slave_title.vue').default);

Vue.component('editor-panel', require('./Editor/vue/editor-panel.vue').default);
Vue.component('editor-text', require('./Editor/vue/editor-text.vue').default);
Vue.component('editor', require('./Editor/vue/editor.vue').default);

Vue.component('editor-text-styles', require('./Editor/vue/editor-text-styles.vue').default);

Vue.component('editor-panel-title', require('./Editor/vue/editor-panel-title.vue').default);
Vue.component('editor-panel-styles', require('./Editor/vue/editor-panel-styles.vue').default);
Vue.component('editor-panel-job-template', require('./Editor/vue/editor-panel-job-template.vue').default);
Vue.component('editor-panel-overrides', require('./Editor/vue/editor-panel-overrides.vue').default);
Vue.component('editor-panel-versions', require('./Editor/vue/editor-panel-versions.vue').default);

Vue.component('lp-label', require('./Editor/vue/lp-label.vue').default);